import { Entity, mapEntity } from '@api';
import { FlagIcon } from '@terminal/components/flag-icon/FlagIcon';
import { useTranslation } from 'react-i18next';

import styles from './ExchangeCard.module.scss';

export interface ExchangeCardProps {
  entity: Entity;
}

export const ExchangeCard = ({ entity }: ExchangeCardProps) => {
  const { t } = useTranslation(['countries', 'analyze']);

  const countryCode = entity.trading_country?.long || entity.country?.long;
  const mappedEntity = mapEntity(entity);

  return (
    <div className={styles.exchangeCardRoot} data-testid="exchange-card">
      <div className={styles.details}>
        <span className={styles.title}>{entity.exchange.code}</span>
        {mappedEntity.sub_class && (
          <span className={styles.subtitle}>
            {
              /* i18next-extract-disable-next-line */
              t(`analyze:assetSubClass.${mappedEntity.sub_class}`)
            }
          </span>
        )}
      </div>
      {countryCode && (
        <div className={styles.country}>
          <FlagIcon
            countryCode={countryCode}
            variant="circular"
            customSize={24}
          />
        </div>
      )}
    </div>
  );
};
